import { Component } from '@angular/core';
import {
  ResourceHeroComponent,
  ResourceHeroSlide,
} from '../../shared/components/resource-hero/resource-hero.component';
import { CalloutsComponent } from './callouts/callouts.component';
import { CardsComponent } from './cards/cards.component';
import { References } from './references/references';
import { AboutTheSurveyComponent } from './about-the-survey/about-the-survey.component';
import { JumpToComponent } from '../../shared/components/jump-to/jump-to.component';
import { ReviewBarComponent } from '../../shared/components/review-bar/review-bar.component';

@Component({
  selector: 'family-history',
  imports: [
    JumpToComponent,
    ResourceHeroComponent,
    CalloutsComponent,
    CardsComponent,
    AboutTheSurveyComponent,
    References,
    ReviewBarComponent
  ],
  templateUrl: './family-history.component.html',
  styleUrl: './family-history.component.scss',
})
export class FamilyHistoryComponent {
  heroSlides: ResourceHeroSlide[] = [
    {
      id: 't1d-family-history',
      backgroundImageName: 't1d-family-history-bg',
      backgroundUsesTabletVariant: false,
      sillhouetteImageName: 'hero-sillhouette-t1d-family-history',
      sillhouetteUsesTabletVariant: false,
      sillhouette: {
        mobile: {
          width: 341,
          top: -43,
          right: 48,
        },
        tablet: {
          width: 436,
          top: -46,
          right: 77,
        },
        desktop: {
          width: 589,
          top: -64,
          right: 104,
        },
      },
      disclaimer: {
        mobile: {
          left: 193,
          bottom: 5,
        },
        tablet: {
          left: 188,
          bottom: 30,
        },
        desktop: {
          left: 9,
          bottom: 34,
        },
      },
      sillhouetteAlt: 'A mother and son with their doctor',
      title: `HELPING <br class="d-none d-lg-block" />PATIENTS <br class="d-none d-lg-block" />UNDERSTAND <br class="d-none d-lg-block" /><span class="text-primary"><em>FAMILY RISK</em></span>`,
      text: `Patients with a first-degree family history of T1D face substantially elevated risk, yet discussions about risk and screening are not consistently happening. Healthcare providers have a critical opportunity to help patients understand their risk and make informed decisions about screening.<sup>1,2</sup>`,
      isFirstSlide: true
    },
  ];

  jumpToData = [
    {
      buttonLabel: 'Urgent gaps',
      buttonUrl: '/',
      buttonFragment: 'urgent-gaps',
    },
    {
      buttonLabel: 'Family risk',
      buttonUrl: '/',
      buttonFragment: 'family-risk',
    },
    {
      buttonLabel: 'Misconceptions',
      buttonUrl: '/',
      buttonFragment: 'misconceptions',
    },
    {
      buttonLabel: 'Discussing screening',
      buttonUrl: '/',
      buttonFragment: 'discussing-screening',
    },
  ];
}
